import React from 'react';
import FormWrapper from '../../../BaseModule/Components/Form/FormWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import styles from './UserWalletRedeemCode.module.scss';
import InputWithSubmitField from '../../../BaseModule/Components/Form/Components/InputWithSubmitField/InputWithSubmitField';
import { useActivateRedeemCodeMutation } from '../../../../graphql/graphql';
import useNotification from '../../../../Hooks/useNotification';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	onRedeemCode: () => void;
}

const UserWalletRedeemCode: React.FC<Props> = ({ onRedeemCode }) => {
	const [redeemCode] = useActivateRedeemCodeMutation({});
	const { showNotificationAlert } = useNotification();
	const { t } = useTranslation();

	const validationSchema = yup.object({
		promoCode: yup
			.string()
			.required(t('validation.userWalletRedeemCode.promoCode')),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		if (values?.promoCode) {
			const result = await redeemCode({
				input: { redeemCode: values.promoCode },
			});
			// @ts-ignore
			if (result.error?.errors) {
				showNotificationAlert({
					content: t('component.userWalletRedeemCode.invalidVoucherCode'),
				});
			}
			onRedeemCode();
		}
	};

	return (
		<div className={styles.wrapper}>
			<FormWrapper formMethods={formMethods} style={{ width: '100%' }}>
				<InputWithSubmitField
					name='promoCode'
					label='component.userWalletRedeemCode.enterVoucherCode'
					onSubmit={handleSubmit}
					isRequired
				/>
			</FormWrapper>
		</div>
	);
};

export default UserWalletRedeemCode;
